var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 24,
    viewBox: "0 0 95 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3064_29618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 43,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4375 5H0V19H42.4375V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3064_29618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0139 5.4479L18.2113 18.5809H14.8222L17.6258 5.4479H21.0139ZM35.2735 13.9274L37.0573 8.99648L38.084 13.9274H35.2735ZM39.0551 18.5809H42.1897L39.4535 5.4479H36.5603C35.9097 5.4479 35.3611 5.82749 35.118 6.41141L30.032 18.5809H33.5909L34.2976 16.6191H38.6459L39.0551 18.5809ZM30.2089 14.293C30.2234 10.8269 25.4274 10.6359 25.4604 9.08752C25.4706 8.61631 25.9183 8.11536 26.898 7.98732C27.3836 7.92356 28.7217 7.87488 30.2393 8.57508L30.8346 5.79024C30.0191 5.49362 28.9699 5.20801 27.6643 5.20801C24.3142 5.20801 21.9568 6.99319 21.9368 9.54924C21.9152 11.4399 23.6196 12.4949 24.9036 13.1231C26.2246 13.7666 26.6677 14.1799 26.6628 14.7554C26.6533 15.6365 25.6092 16.0254 24.6334 16.0406C22.9299 16.0668 21.9414 15.5785 21.1533 15.2112L20.539 18.0884C21.331 18.4526 22.7926 18.7703 24.3082 18.7861C27.8689 18.7861 30.198 17.0233 30.2089 14.293ZM16.1713 5.4479L10.6799 18.5809H7.09733L4.39507 8.10014C4.23094 7.45451 4.08844 7.21814 3.58951 6.94624C2.77495 6.50315 1.42958 6.08764 0.246094 5.8296L0.326507 5.4479H6.09359C6.8287 5.4479 7.4895 5.93843 7.65634 6.78703L9.08352 14.3865L12.6108 5.4479H16.1713Z",
    fill: "#1434CB"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3064_29618)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3064_29618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 2,
    width: 33,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9375 2H62.4375V22H94.9375V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3064_29618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1009 4.13818H74.2944V19.8621H83.1009V4.13818Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8536 12C74.8522 10.4857 75.1975 8.99085 75.8635 7.62875C76.5295 6.26664 77.4987 5.07294 78.6976 4.138C77.213 2.97846 75.4298 2.25735 73.5521 2.05711C71.6745 1.85687 69.7779 2.18556 68.0794 3.00563C66.3808 3.8257 64.9487 5.10406 63.9468 6.69458C62.9449 8.2851 62.4136 10.1236 62.4136 12C62.4136 13.8763 62.9449 15.7148 63.9468 17.3054C64.9487 18.8959 66.3808 20.1742 68.0794 20.9943C69.7779 21.8144 71.6745 22.1431 73.5521 21.9428C75.4298 21.7426 77.213 21.0215 78.6976 19.862C77.4987 18.927 76.5295 17.7333 75.8635 16.3713C75.1976 15.0091 74.8522 13.5143 74.8536 12Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9813 12C94.9814 13.8763 94.4502 15.7148 93.4483 17.3053C92.4464 18.8958 91.0144 20.1742 89.3158 20.9943C87.6173 21.8144 85.7208 22.1431 83.8432 21.9428C81.9655 21.7426 80.1824 21.0215 78.6978 19.862C79.8957 18.9261 80.8641 17.7322 81.5299 16.3703C82.1958 15.0084 82.5418 13.5141 82.5418 12C82.5418 10.4859 82.1958 8.99156 81.5299 7.62967C80.8641 6.26778 79.8957 5.07388 78.6978 4.138C80.1824 2.97845 81.9655 2.25735 83.8432 2.05711C85.7208 1.85687 87.6173 2.18558 89.3158 3.00565C91.0144 3.82573 92.4464 5.10409 93.4483 6.69461C94.4502 8.28513 94.9814 10.1236 94.9813 12Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0209 18.1968V17.8748H94.1515V17.8093H93.8188V17.8748H93.9495V18.1968H94.0209ZM94.6668 18.1968V17.8086H94.5648L94.4475 18.0756L94.3302 17.8086H94.2282V18.1968H94.3002V17.9039L94.4102 18.1564H94.4848L94.5948 17.9033V18.1968H94.6668Z",
    fill: "#F79E1B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3064_29618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 20,
    fill: "white",
    transform: "translate(62.4375 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaMaster);
export default __webpack_public_path__ + "static/media/visa_master.26ca33e1b19ec6bf286be780f442ba5a.svg";
export { ForwardRef as ReactComponent };